module.exports = __webpack_public_path__ + "static/media/my.cd942bda.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/my.svg
// module id = 903
// module chunks = 0